import { useEffect, useState } from 'react';
import { Modal, Button } from '@indipia/ui-core';
import { PhotoSelectGrid } from './PhotoSelectGrid';
import type { SelectedPhoto } from '../types/portfolio.types';

interface Props {
  open: boolean;
  onClose: () => void;
  initialSelected: SelectedPhoto[];
  onConfirm: (photos: SelectedPhoto[]) => void;
}

/** 사진 추가·삭제 모달 — 편집/발행분 수정 시 증분 조작. */
export function PhotoPicker({ open, onClose, initialSelected, onConfirm }: Props) {
  const [sel, setSel] = useState<Map<number, SelectedPhoto>>(new Map());

  useEffect(() => {
    if (open) setSel(new Map(initialSelected.map((p) => [p.photoId, p])));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  function toggle(
    photoId: number,
    url: string,
    meta?: { spaceTag?: string | null; siteId?: number | null; siteName?: string | null },
  ) {
    setSel((prev) => {
      const next = new Map(prev);
      if (next.has(photoId)) next.delete(photoId);
      else next.set(photoId, { photoId, url, spaceTag: meta?.spaceTag, siteId: meta?.siteId, siteName: meta?.siteName });
      return next;
    });
  }

  return (
    <Modal open={open} onClose={onClose} title="사진 추가·삭제" size="lg">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <PhotoSelectGrid selected={[...sel.values()]} onToggle={toggle} maxHeight={360} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 4 }}>
          <span style={{ color: 'var(--shell-on-surface-2)', fontSize: 13 }}>{sel.size}장 선택됨</span>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button variant="etc" onClick={onClose}>
              취소
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                onConfirm([...sel.values()]);
                onClose();
              }}
            >
              적용
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
